export interface ICountry {
  name: ECountryName;
  code: ECountry;
  iso2: ECountryIso2Code;
  iso3: ECountryIso3Code;
}

export enum ECountryName {
  FRANCE = "FRANCE",
  UNITED_KINGDOM = "UNITED_KINGDOM",
  SWEDEN = "SWEDEN",
  FINLAND = "FINLAND",
  SPAIN = "SPAIN",
  PORTUGAL = "PORTUGAL",
  SAUDI_ARABIA = "SAUDI_ARABIA",
  UNITED_ARAB_EMIRATES = "UNITED_ARAB_EMIRATES",
}

export enum ECountry {
  FRANCE = "FR",
  UNITED_KINGDOM = "GB",
  SWEDEN = "SW",
  FINLAND = "FI",
  SPAIN = "ES",
  PORTUGAL = "PR",
  SAUDI_ARABIA = "SA",
  UNITED_ARAB_EMIRATES = "AR",
}

export enum ECountryIso2Code {
  FR = "FR",
  GB = "GB",
  SE = "SE",
  FI = "FI",
  ES = "ES",
  PR = "PR",
  SA = "SA",
  AE = "AE",
}

export enum ECountryIso3Code {
  FRA = "FRA",
  GBR = "GBR",
  SWE = "SWE",
  FIN = "FIN",
  ESP = "ESP",
  PRT = "PRT",
  SAU = "SAU",
  ARE = "ARE",
}

export const COUNTRIES: Record<ECountry, ICountry> = {
  [ECountry.FRANCE]: {
    name: ECountryName.FRANCE,
    code: ECountry.FRANCE,
    iso2: ECountryIso2Code.FR,
    iso3: ECountryIso3Code.FRA,
  },
  [ECountry.UNITED_KINGDOM]: {
    name: ECountryName.UNITED_KINGDOM,
    code: ECountry.UNITED_KINGDOM,
    iso2: ECountryIso2Code.GB,
    iso3: ECountryIso3Code.GBR,
  },
  [ECountry.SWEDEN]: {
    name: ECountryName.SWEDEN,
    code: ECountry.SWEDEN,
    iso2: ECountryIso2Code.SE,
    iso3: ECountryIso3Code.SWE,
  },
  [ECountry.FINLAND]: {
    name: ECountryName.FINLAND,
    code: ECountry.FINLAND,
    iso2: ECountryIso2Code.FI,
    iso3: ECountryIso3Code.FIN,
  },
  [ECountry.SPAIN]: {
    name: ECountryName.SPAIN,
    code: ECountry.SPAIN,
    iso2: ECountryIso2Code.ES,
    iso3: ECountryIso3Code.ESP,
  },
  [ECountry.PORTUGAL]: {
    name: ECountryName.PORTUGAL,
    code: ECountry.PORTUGAL,
    iso2: ECountryIso2Code.PR,
    iso3: ECountryIso3Code.PRT,
  },
  [ECountry.SAUDI_ARABIA]: {
    name: ECountryName.SAUDI_ARABIA,
    code: ECountry.SAUDI_ARABIA,
    iso2: ECountryIso2Code.SA,
    iso3: ECountryIso3Code.SAU,
  },
  [ECountry.UNITED_ARAB_EMIRATES]: {
    name: ECountryName.UNITED_ARAB_EMIRATES,
    code: ECountry.UNITED_ARAB_EMIRATES,
    iso2: ECountryIso2Code.AE,
    iso3: ECountryIso3Code.ARE,
  },
};
